import { useEffect, useState, useContext } from 'react'
import { Spinner} from 'react-bootstrap'
import {MDBTooltip} from 'mdbreact'
import {AiFillQuestionCircle} from 'react-icons/ai'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import ReportsService from '../../services/ReportsService'
import CommonService from '../../services/CommonService'
import { toast } from 'react-toastify';
import { UserContext } from '../../UseContext'
import DataGrid from '../GenericComponents/DataGrid'
import { Column } from 'primereact/column'
import { configManager } from '../../configManager'
import { useMsal } from '@azure/msal-react'
import TooltipComponent from '../../common/Tooltip'
import { SplitButton } from 'primereact/splitbutton'

export const checkIfReviewedReportCanEdit = async (reportData, navigate, instance) => {
    var obj ={
        "msgId": null,
        "sysId": null,
        "opr": "isReviewedAdtrCanEdit",
        "hdrStruct": null,
        "queryParam": null,
        "reqData": {
            "finalSaleId" : reportData.finalSaleId,
            "fiscalYrEndDate" : reportData.fiscalYrEndDate
        }
      } ;
  
    await ReportsService.isReviewedReportCanEdit(obj)
    .then((res) => res)
    .then(async (result) => {
        if (result.data.errors && result.data.errors.length > 0){
            CommonService.handleServerResponse(result.data, instance);
        } else {
            const response = result.data.responses[0];
            if("reviewedReportsExists" in response) {
                swal(response["reviewedReportsExists"]);
            } else if("inProcessReportsExists" in response) {
                swal({
                    text: response["inProcessReportsExists"] + "Do you want to continue?",
                    icon: "warning",
                    buttons: [true, 'Yes'],
                    closeOnClickOutside: false
                  })
                  .then((confirm) => {
                    if (confirm) {
                        navigate(`/adtr-yfs/${reportData.cdiacNbr}`, {state:{appState: reportData}});                        } 
                  });
            } else {
                navigate(`/adtr-yfs/${reportData.cdiacNbr}`, {state:{appState: reportData}});
            }
        }
    });
}

const ADTRReports = (props) => {
    const {instance} = useMsal();
    const loginUserId = useContext(UserContext)
    const {issuerId, reportStatus, searchCriteria} = props;
    const navigate = useNavigate();
    const [adtrs, setAdtrs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getAdtrWorkLoad(issuerId);
    // eslint-disable-next-line
    }, [issuerId, searchCriteria]);

    const getAdtrWorkLoad = (issuerId) => {
        setIsLoading(true);
        setAdtrs([]);
        let obj;
        if(reportStatus === "view-previous") {
            obj ={
                "msgId": null,
                "sysId": null,
                "opr": "getOldAdtrs",
                "hdrStruct": null,
                "queryParam": null,
                "reqData": {
                    "id" : issuerId,
                    "env" : 'E',
                    "searchCriteria": searchCriteria
                }
            }
        } else {
            obj = {
                "msgId": null,
                "sysId": null,
                "opr": "getPendingAdtrs",
                "hdrStruct": null,
                "queryParam": null,
                "reqData": {
                    "id" : issuerId,
                    "env" : 'E'
                }
            }
        } 
        ReportsService.getReports(obj)
        .then((res) => res)
        .then((result) => {
            if (result.data.errors && result.data.errors.length > 0){
                CommonService.handleServerResponse(result.data, instance)
            }
            else{
                setAdtrs(result.data.responses[0]);
            }
            setIsLoading(false);
        });
    }
    const actions = {
        'D' : [
            {value:'E', label: 'Edit'},
            {value:'C', label: 'Cancel'},
            {value:'SH', label: 'View History'}
        ],
        'R' : [
            {value:'E', label: 'Edit'},
            {value:'SH', label: 'View History'},
            {value:'DW', label: 'View in DebtWatch'}
        ],
        'S' : [
            {value:'E', label: 'Edit'},
            {value:'C', label: 'Cancel'},
            {value:'SH', label: 'View History'}
        ],
        'PD' : [
            {value:'PD', label: 'Report ADTR'},
            {value:'SH', label: 'View History'}
        ],
        'PEND' : [
            {value:'PEND', label: 'Report ADTR'},
            {value:'SH', label: 'View History'}
        ],
        'E' : [
            {value:'E', label: 'Edit'},
            {value:'SH', label: 'View History'}
        ],
    }
    const viewFormatter = (row) => {
        const items =  actions[row['statusFlag']].map((action, i)=> {
            if(action.value === "DW") {
                const fiscalYear = new Date(row['fiscalYrEndDate']).getFullYear();
                const canViewInDW = (fiscalYear <= row['adtrPublicationYear']);
                const tooltipText = `ADTRs for reporting years after ${row['adtrPublicationYear']} are not yet published in DebtWatch.`
                if(!canViewInDW) {
                    return ( {
                        template: () => {
                            return (
                                <TooltipComponent title={tooltipText} placement="left" className="ml-0" key={i}>
                                <div class="p-menuitem-content" data-pc-section="content">
                                    <a href="/" class="p-menuitem-link p-disabled" data-pc-section="action" tabIndex="-1" >
                                    <span class="p-menuitem-text" data-pc-section="label">{action.label}</span>
                                    </a>
                                </div>
                                </TooltipComponent>
                            )
                        }
                    })
                }
            }
            return ( {
                label: action.label,
                key: i,
                command: (e) => {
                    handleActionClick(e, action.value, row )
                },
                title: action.label
            })
            
         });
        return ( 
            <div style={{ textAlign: "center", lineHeight: "normal" }}>
                {reportStatus === "view-previous" && row['retiredFlag'] === "No" ?
                <span>Not Applicable</span> :
                <div>
                    <SplitButton 
                        label="Action" 
                        model={items} 
                        severity='secondary' 
                        size='small' 
                    />
                </div>
                }
            </div> 
        ); 
    }

    const cancelAdtr = (adtrId) => {
        var obj ={
            "msgId": null,
            "sysId": null,
            "opr": "cancelAdtr",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "id" : adtrId,
                "user" : loginUserId,
                "env" : 'E'
            }
          } ;
      
        ReportsService.cancelReport(obj)
        .then((res) => res)
        .then(async (result) => {
            if (result.data.errors && result.data.errors.length > 0){
                toast.error(result.data.errors[0].message);
                setIsLoading(false);
            }
            else{
                toast.success("The transaction has been cancelled and an acknowledgement email has been sent.");
                getAdtrWorkLoad(issuerId);
            }
        });
    }

    const handleActionClick = (e, action, row) => {
        const adtrId = row.adtrId;
        if( action === 'C' ) {
            swal("Are you sure you want to permanently cancel this transaction?", {
                buttons: ["No", "Yes"],
            }).then((value) => {
               if(value){
                cancelAdtr(adtrId);
               }
            });
        } else if( action === 'E') {
            const status = row.statusFlag;
            if(status === 'R') {
                checkIfReviewedReportCanEdit(row, navigate, instance);
            } else {
                navigate(`/adtr-yfs/${row.cdiacNbr}`, {state: {appState:row}});
            }
        } else if( action === 'PEND') {
            navigate(`/adtr/${row.cdiacNbr}`, {state:{appState: row}});
        } else if( action === 'PD') {
            navigate(`/adtr/${row.cdiacNbr}`, {state:{appState: row}});
        } else if( action === 'R') {
            alert("Clicked Review");
        } else if( action === 'SH') {
            navigate(`/status-history-upload-documents/${row.cdiacNbr}`);
        } else if( action === 'DW') {
            window.open( `${configManager.debtWatchUrl}/issue-level-detail?cdiacNumber=${row.cdiacNbr}`);
        }
    }   
    const viewHeaderFormatter = (row, column) => {
        return (<>{column.text}
        { column.headerFormatter && <MDBTooltip domElement tag="span" placement="right" >
            <span>{"  "}<AiFillQuestionCircle className="help-icon heading-help-icon"/></span>
            <span>Click on the Action button to view the actions that may be taken with the specific report and CDIAC # listed.</span>
        </MDBTooltip>
        }
        </>);
    }
    const columns = [{
        dataField: 'cdiacNbr',
        text: 'CDIAC #',
        sort: true
      }, 
      {
        dataField: 'fiscalYrEndDate',
        text: 'Fiscal Yr End Date',
        sort: true,
        formatter: (row) => CommonService.dateFormatter(row['fiscalYrEndDate'])
      },
      {
        dataField: 'issueStatus',
        text: 'Status',
        sort: true
      },{
        dataField: 'issueName',
        text: 'Issue Name',
        sort: true
      }, {
        dataField: 'projectName',
        text: 'Project Name',
        sort: true
      }, {
        dataField: 'actualSaleDate',
        text: 'Actual Sale Date',
        sort: true,
        formatter: (row) => CommonService.dateFormatter(row['actualSaleDate'])
      },{
        dataField: 'principalSaleAmt',
        text: 'Principal Amount',
        sort: true,
        formatter: (row) => CommonService.currencyFormatter(row['principalSaleAmt'])
      },{
        dataField: 'retiredFlag',
        text: 'Ongoing Reportable',
        sort: true,
        hidden: reportStatus === "view-previous" ? false : true
      },{ 
        dataField: "",
        text: "Action", 
        formatter: viewFormatter,
        headerFormatter: viewHeaderFormatter
    }
    
    ]
    return (
        <div>
            {isLoading ? <Spinner animation="border" variant="primary" /> :
             <DataGrid
             title="Annual Debt Transparency Reports"
             dataSource={adtrs}
             sortField='cdiacNbr'
             searchToolTip="Use the search feature to find a specific issue within the dashboard. Click on the dashboard column headings to sort."
             emptyDataMessage='No data available to display'
             >
             {columns.map((column, i) => {
                 return (
                 <Column 
                 key={i}
                 field={column.dataField}
                 header={(row) => viewHeaderFormatter(row, column)}
                 sortable={column.sort} 
                 body={column.formatter}
                 hidden={column.hidden}
                 />)
                 }) 
             } 
             </DataGrid>
            } 
        </div>
    )
}

export default ADTRReports
